import React from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import { CtaButton } from "../../signupComponents";

const styles = theme => ({
  title: {
    paddingLeft: "5px"
  },
  mainDiv: {
    width: "75%",
    "@media (max-width: 420px)": {
      width: "90%"
    }
  },
  pageHeaders: {
    color: "#094066",
    marginBottom: "20px",
    fontFamily: '"Ubuntu","Helvetica","Arial",sans-serif !important'
  },
  thankYou: {
    fontWeight: "100",
    color: "rgb(44 67 115)",
    fontFamily: '"Ubuntu","Helvetica","Arial",sans-serif !important'
  },
  contactNumber: {
    color: "rgb(44 67 115)",
    fontWeight: "bold",
    fontFamily: '"Ubuntu","Helvetica","Arial",sans-serif !important'
  },
  contactNumberId: {
    color: "rgb(244 71 88) !important"
  },
  visitButton: {
    height: "40px",
    fontWeight: 600,
    fontFamily: '"Ubuntu","Helvetica","Arial",sans-serif !important'
  },
  actionRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 12,
    marginTop: 18
  },
  planSection: {
    marginTop: 28
  },
  plansTitle: {
    color: "#1f2f50",
    fontWeight: 800,
    marginBottom: 14,
    fontFamily: '"Ubuntu","Helvetica","Arial",sans-serif !important'
  },
  planGrid: {
    marginTop: 4
  },
  planCard: {
    height: "100%",
    borderRadius: 16,
    border: "1px solid #dae4f1",
    boxShadow: "0 12px 26px rgba(9, 30, 66, 0.12)",
    overflow: "hidden",
    backgroundColor: "#fff"
  },
  planHeader: {
    background: "linear-gradient(120deg, #8b1224 0%, #d84459 100%)",
    padding: "14px 16px 12px"
  },
  planHeaderAlt: {
    background: "linear-gradient(120deg, #0f4f7d 0%, #1f7eb6 100%)",
    padding: "14px 16px 12px"
  },
  planHeaderDefault: {
    background: "linear-gradient(120deg, #284f7a 0%, #3c6c99 100%)",
    padding: "14px 16px 12px"
  },
  planTitle: {
    color: "#fff",
    fontWeight: 700,
    marginBottom: 0,
    fontSize: 21
  },
  planSubhead: {
    marginTop: 4,
    color: "rgba(255,255,255,0.9)",
    fontSize: 13
  },
  planBody: {
    padding: "14px 16px"
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    padding: "8px 0",
    borderBottom: "1px solid #ecf1f7"
  },
  rowLabel: {
    color: "#244373",
    fontSize: 13,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 0.4
  },
  rowValue: {
    color: "#123c61",
    fontSize: 18,
    fontWeight: 700
  },
  rowValuePrefix: {
    fontSize: 11,
    fontWeight: 600,
    textTransform: "none",
    letterSpacing: 0.2,
    marginRight: 6,
    color: "#5b7390",
    verticalAlign: "middle"
  },
  rowValueSmall: {
    fontSize: 12,
    fontWeight: 500,
    marginLeft: 2,
    color: "#5b7390"
  },
  emptyPlans: {
    color: "#244373",
    marginTop: 10
  },
  disclaimerWrap: {
    marginTop: 14,
    color: "#244373"
  },
  disclaimerItem: {
    marginTop: 8,
    fontSize: 13,
    lineHeight: 1.45
  }
});

const Fin = props => {
  const { classes } = props;
  const regularPackages = Array.isArray(props.regularpackages)
    ? props.regularpackages
    : [];

  const formatMoney = value => {
    const amount = Number(value);
    if (Number.isNaN(amount)) return value;
    return amount.toFixed(2);
  };

  const getTrafficCap = pkg => {
    if (!Array.isArray(pkg.details)) return "N/A";
    const match = pkg.details.find(line =>
      String(line)
        .toLowerCase()
        .includes("traffic cap:")
    );
    if (!match) return "N/A";
    const parts = String(match).split(":");
    return parts.length > 1
      ? parts
          .slice(1)
          .join(":")
          .trim()
      : String(match);
  };

  const kbpsToMbpsDisplay = kbpsValue => {
    const kbps = Number(kbpsValue);
    if (Number.isNaN(kbps)) return "N/A";

    // Backend now sends kbps. 1,000,000 kbps package is marketed as 940 Mbps.
    if (kbps === 1000000) return "940";

    const mbps = kbps / 1000;
    if (mbps >= 100) return String(Math.round(mbps));
    if (mbps >= 10) return mbps.toFixed(1).replace(/\.0$/, "");
    return mbps
      .toFixed(2)
      .replace(/0$/, "")
      .replace(/\.0$/, "");
  };

  return (
    <div className={classes.mainDiv}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h3" className={classes.pageHeaders}>
            MCSnet Signup
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.title}>
          <Typography variant="h4" className={classes.thankYou}>
            Thank you for your interest in MCSnet high speed Internet! <br />
          </Typography>
          <br />
          <br />
          <Typography variant="h6">
            An MCSnet representative will contact you as soon as possible.
          </Typography>
          <br />
          <br />
          <Typography variant="h6" className={classes.contactNumber}>
            Your contact number is{" "}
            {props.agent ? (
              <a
                href={`https://bams.mcsnet.ca/ui/contact/${
                  props.contactid
                }/general`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {props.contactid}
              </a>
            ) : (
              <span className={classes.contactNumberId}>
                {" "}
                {props.contactid}{" "}
              </span>
            )}
          </Typography>
        </Grid>

        <Grid item xs={12} className={classes.planSection}>
          <Typography variant="h5" className={classes.plansTitle}>
            Home Internet Plans & Pricing
          </Typography>
          {regularPackages.length === 0 ? (
            <Typography variant="body1" className={classes.emptyPlans}>
              No regular packages are available for this location right now.
            </Typography>
          ) : (
            <Grid container spacing={2} className={classes.planGrid}>
              {regularPackages.map((pkg, index) => (
                <Grid item xs={12} md={6} key={pkg.id}>
                  <Card className={classes.planCard}>
                    <div
                      className={
                        index === 0
                          ? classes.planHeader
                          : index === 1
                          ? classes.planHeaderAlt
                          : classes.planHeaderDefault
                      }
                    >
                      <Typography variant="h6" className={classes.planTitle}>
                        {pkg.description}
                      </Typography>
                      <Typography className={classes.planSubhead}>
                        Free installation with a 2-year term*
                      </Typography>
                    </div>
                    <CardContent className={classes.planBody}>
                      <div className={classes.row}>
                        <Typography className={classes.rowLabel}>
                          Fee
                        </Typography>
                        <Typography className={classes.rowValue}>
                          ${formatMoney(pkg.total_monthly_fee)}
                          <span className={classes.rowValueSmall}>/month</span>
                        </Typography>
                      </div>
                      <div className={classes.row}>
                        <Typography className={classes.rowLabel}>
                          Traffic
                        </Typography>
                        <Typography className={classes.rowValue}>
                          {getTrafficCap(pkg)}
                        </Typography>
                      </div>
                      <div className={classes.row}>
                        <Typography className={classes.rowLabel}>
                          Top Download Speed
                        </Typography>
                        <Typography className={classes.rowValue}>
                          <span className={classes.rowValuePrefix}>Up to</span>
                          {kbpsToMbpsDisplay(pkg.rate_download)}
                          <span className={classes.rowValueSmall}>Mbps</span>
                        </Typography>
                      </div>
                      <div className={classes.row}>
                        <Typography className={classes.rowLabel}>
                          Top Upload Speed
                        </Typography>
                        <Typography className={classes.rowValue}>
                          <span className={classes.rowValuePrefix}>Up to</span>
                          {kbpsToMbpsDisplay(pkg.rate_upload)}
                          <span className={classes.rowValueSmall}>Mbps</span>
                        </Typography>
                      </div>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
          <div className={classes.disclaimerWrap}>
            <Typography variant="body2" className={classes.disclaimerItem}>
              • All packages include 1 dynamic IP address.
            </Typography>
            <Typography variant="body2" className={classes.disclaimerItem}>
              • Pre-authorized payment (PAP) through bank (EFT) or credit card
              is required for all plans.
            </Typography>
            <Typography variant="body2" className={classes.disclaimerItem}>
              • We are an ‘Up to’ service, and maximum internet speed is not
              guaranteed. Speeds may vary depending on the tower equipment
              servicing your site, your radio signal to that tower, the
              construction materials of your home, location and configuration of
              your Wi-Fi router, location and capabilities of Wi-Fi devices,
              number of active Wi-Fi devices or other factors.
            </Typography>
          </div>
          <div className={classes.actionRow}>
            <CtaButton
              component="a"
              href="https://mcsnet.ca/"
              className={classes.visitButton}
              variant="contained"
            >
              Visit MCSNet.ca
            </CtaButton>
            {props.signupEventCode && typeof props.startOver === "function" ? (
              <CtaButton
                type="button"
                onClick={props.startOver}
                className={classes.visitButton}
                variant="contained"
              >
                Start another signup
              </CtaButton>
            ) : null}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(Fin);
